import { useMemo } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { useIsAdmin } from "../../hooks/useIsAdmin";
import { useSession } from "../../hooks/useSession";
import { supabase } from "../../lib/supabaseClient";
import "./Navigator.css";

export default function Navigator() {
    const navigate = useNavigate();

    const { session, loading: sessionLoading } = useSession();
    const { isAdmin } = useIsAdmin();

    const user = session?.user ?? null;

    const signOut = async () => {
        await supabase.auth.signOut();
        navigate("/");
    };

    const links = useMemo(() => {
        const base = [
            { to: "/", label: "Browse" },
            { to: "/contribute", label: "Contribute" },
        ];
        if (user) base.push({ to: "/me", label: "My Profile" });
        if (isAdmin === true) base.push({ to: "/admin", label: "Admin" });

        return base;
    }, [isAdmin, user]);

    return (
        <header className="nav-shell">
            <div className="nav-inner">
                <div className="nav-title">WookRook’s Palia Pocket Guide</div>

                <nav className="nav-center">
                    {links.map((s) => (
                        <NavLink
                            key={s.to}
                            to={s.to}
                            end={s.to === "/"}
                            className={({ isActive }) =>
                                isActive ? "nav-pill active" : "nav-pill"
                            }
                        >
                            {s.label}
                        </NavLink>
                    ))}
                </nav>

                <div className="nav-right">
                    <a
                        href="https://wookrook.com"
                        className="nav-pill nav-external"
                    >
                        ← Wookrook.com
                    </a>

                    {sessionLoading ? null : user ? (
                        <div className="nav-user-greet">
                            Hey, {user.user_metadata?.username || "User"}!{" "}
                            <button
                                className="nav-pill nav-signout"
                                onClick={signOut}
                            >
                                Sign out
                            </button>
                        </div>
                    ) : (
                        <button
                            className="nav-pill nav-signout"
                            onClick={() => navigate("/login")}
                        >
                            Sign In
                        </button>
                    )}
                </div>
            </div>
        </header>
    );
}
